import React, { Component } from 'react'
import AddMaterial from '@common/AddMaterial'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import { Empty } from 'hljd'
import Style from './index.module.less'
import Item from './Item'

@observer
export default class extends Component {
  checkImg = checked => {
    return (
      <img
        className={Style.isCheck}
        height={24}
        width={24}
        src={
          checked
            ? 'https://qnm.hunliji.com/o_1daofbem7vse18r18ilrst10sc9.png'
            : 'https://qnm.hunliji.com/o_1daofga7k5br1noo1f2v1alv1egie.png'
        }
      />
    )
  }

  render() {
    const {
      onCancel,
      visibility,
      allList,
      checkList,
      onOk,
      title,
      emptyDesc
    } = this.props
    return (
      <AddMaterial
        title={
          <p>
            <span style={{ fontSize: 16, fontWeight: 'bold' }}>{title}</span>
          </p>
        }
        Item={Item}
        list={toJS(allList)}
        visibility={visibility}
        onOk={onOk}
        onCancel={onCancel}
        checkList={checkList}
        emptyEle={
          <div style={{ textAlign: 'center' }}>
            <Empty description={<span />} />
            <p style={{ color: '#999' }}>{emptyDesc}</p>
          </div>
        }
        checkedIcon={this.checkImg}
      />
    )
  }
}
